import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'printTemplate',
    'calculatorContainer'
  ]

  handlePrint(event) {
    event.preventDefault()
    if (!this.hasPrintTemplateTarget) return

    const marketRatesSlot = Array.from(this.printTemplateTarget.content.children).find(t => t.dataset.role === 'content').content.querySelector('[data-print*="market-rates-slot"]')
    const marketRates = document.querySelector('[data-print*="market-rates"]')
    marketRatesSlot.innerHTML = marketRates.innerHTML

    const page1ContentHtml = printFunctions.getPage1Content(this.calculatorContainerTarget, marketRatesSlot)
    const page2ContentHtml = printFunctions.getPage2Content(this.calculatorContainerTarget, marketRatesSlot)
    const page3ContentHtml = printFunctions.getPage3Content(this.calculatorContainerTarget, marketRatesSlot)
    const page4ContentHtml = printFunctions.getPage4Content(this.calculatorContainerTarget)

    const data = {
      pages: [
        {
          title: 'Vessel Comparison Report - Summary',
          content: page1ContentHtml
        },
        {
          title: 'Analysis - Index',
          content: page2ContentHtml
        },
        {
          title: 'Analysis - Speeds',
          content: page3ContentHtml
        },
        {
          title: 'Vessel Features',
          content: page4ContentHtml
        },
      ]
    }

    this.printTemplateTarget.dispatchEvent(new CustomEvent('print-template', { detail: data }))
  }
}

const printFunctions = (function () {

  function _toggleCollapseSections(sections, sectionsToShow) {
    sections.forEach(section => {
      const isSectionVisible = section.classList.contains('show')
      const dataPrintValues = section.dataset.print.split(' ')
      const isSectionToShow = sectionsToShow.some(sectionToShow => dataPrintValues.includes(sectionToShow))
      if (isSectionVisible && !isSectionToShow) {
        section.classList.remove('show')
      } else if (!isSectionVisible && isSectionToShow) {
        section.classList.add('show')
      }
    })
  }

  function _showElements(container, elements) {
    _toggleElementsVisibility(container, elements, 'show')
  }

  function _hideElements(container, elements) {
    _toggleElementsVisibility(container, elements, 'hide')
  }
  function _toggleElementsVisibility(container, elements, action = 'show') {
    if (!container || !elements) return
    elements.forEach(element => {
      const elements = container.querySelectorAll(`[data-print*="${element}"]`)
      elements.forEach(element => {
        element.style.display = action === 'show' ? 'block' : 'none'
      })
    })
  }
  function _showOnlyFirst4Vessels(container) {
    if (!container) return container

    Array.from(container.querySelectorAll('[data-print*="calc-vessel"]'))?.forEach((vessel, index) => {
      if ((index + 1) > 4) {
        const vesselForm = vessel.closest('[data-print*="vessel-form"]')
        if (vesselForm) {
          vesselForm.remove()
        }
      }
    })
  }

  function getSections(container) {
    const sections = container.querySelectorAll('[data-print*="calculator-section"]')
    return sections
  }

  function getPage1Content(calculatorContainer, marketRatesContent) {
    const page1Content = calculatorContainer.cloneNode(true)

    _showOnlyFirst4Vessels(page1Content)

    // toggle all calculator sections to show only the vessel particulars and speeds consumption
    const calculatorSections = getSections(page1Content)
    const sectionsToShow = ['vessel-particulars', 'speeds-consumption']
    _toggleCollapseSections(calculatorSections, sectionsToShow)

    _hideElements(page1Content, ['vessel-features', 'ghg', 'eexi'])

    return `
      <div class="calculator-print-page">
        ${page1Content.outerHTML}
        ${marketRatesContent.outerHTML}
      </div>
    `
  }

  function getPage2Content(calculatorContainer, marketRatesContent) {
    const page2Content = calculatorContainer.cloneNode(true)

    _showOnlyFirst4Vessels(page2Content)

    // expand VESSELINDEX® section
    const calculatorSections = getSections(page2Content)
    const sectionsToShow = ['vessel-index', 'sisterships-index', 'average-index']
    _toggleCollapseSections(calculatorSections, sectionsToShow)

    // hide voyages and show speeds
    _showElements(page2Content, ['vessel-index', 'sisterships-index', 'optispeed-voyages', 'voyages-labels'])

    // Hide all other sections
    _hideElements(page2Content, ['optispeed-speed', 'speed-labels', 'vessel-particulars', 'vessel-features', 'speeds-consumption', 'custom-index', 'average-custom-index', 'button-sections', 'ghg', 'eexi'])

    return `
      <div class="calculator-print-page">
        ${page2Content.outerHTML}
        ${marketRatesContent.outerHTML}
      </div>
    `
  }
  function getPage3Content(calculatorContainer, marketRatesContent) {
    const page3Content = calculatorContainer.cloneNode(true)

    _showOnlyFirst4Vessels(page3Content)

    // expand VESSELINDEX® section
    const calculatorSections = getSections(page3Content)
    const sectionsToShow = ['vessel-index', 'sisterships-index', 'average-index']
    _toggleCollapseSections(calculatorSections, sectionsToShow)

    // hide voyages and show labels
    _showElements(page3Content, ['vessel-index', 'sisterships-index', 'optispeed-speed', 'speed-labels'])

    // Hide all other sections
    _hideElements(page3Content, ['optispeed-voyages', 'voyages-labels', 'vessel-particulars', 'vessel-features', 'speeds-consumption', 'custom-index', 'average-custom-index', 'button-sections', 'ghg', 'eexi'])

    return `
      <div class="calculator-print-page">
        ${page3Content.outerHTML}
        ${marketRatesContent.outerHTML}
      </div>
    `
  }
  function getPage4Content(calculatorContainer) {
    const page4Content = calculatorContainer.cloneNode(true)

    _showOnlyFirst4Vessels(page4Content)

    // expand Vessel Features section
    const calculatorSections = getSections(page4Content)
    const sectionsToShow = ['vessel-features']
    _toggleCollapseSections(calculatorSections, sectionsToShow)

    // Hide all other sections
    _hideElements(page4Content, [
      'vessel-particulars',
      'speeds-consumption',
      'button-sections',
      'vessel-index',
      'sisterships-index',
      'custom-index',
      'ghg',
      'eexi'
    ])

    return `
      <div class="calculator-print-page">
        ${page4Content.outerHTML}
      </div>
    `
  }

  return {
    getPage1Content,
    getPage2Content,
    getPage3Content,
    getPage4Content
  }
})()